import { render, staticRenderFns } from "./SquadraInfoPanel.vue?vue&type=template&id=9ba2ed1e&scoped=true&"
import script from "./SquadraInfoPanel.vue?vue&type=script&lang=js&"
export * from "./SquadraInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./SquadraInfoPanel.vue?vue&type=style&index=0&id=9ba2ed1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2ed1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba2ed1e')) {
      api.createRecord('9ba2ed1e', component.options)
    } else {
      api.reload('9ba2ed1e', component.options)
    }
    module.hot.accept("./SquadraInfoPanel.vue?vue&type=template&id=9ba2ed1e&scoped=true&", function () {
      api.rerender('9ba2ed1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SquadraInfoPanel.vue"
export default component.exports